// src/config.js
export const CONFIG = {
  SMB_IP: process.env.REACT_APP_SMB_IP,
};